var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"neo-number-change"}},[_c('b-card',{attrs:{"header-tag":"header"}},[_c('neo-number-change-form',{attrs:{"has_special_priced_item":_vm.has_special_priced_item}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }